import { render } from "./Outcome.vue?vue&type=template&id=a5d7fa9a&scoped=true&ts=true"
import script from "./Outcome.vue?vue&type=script&lang=ts"
export * from "./Outcome.vue?vue&type=script&lang=ts"

import "./Outcome.vue?vue&type=style&index=0&id=a5d7fa9a&scoped=true&lang=scss"

import exportComponent from "/buddy/openbanking/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5d7fa9a"]])

export default __exports__